import React from 'react';
import AAutoComplete from '../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import AInput from '../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import SelectStatus from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/SelectStatus';
import { Dialog } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

const VendorAccountDetailsDialog = ({
    dialogInfo,
    setDialogInfo,
    dropdownData = {},
}) => {

    const { vendorAccountDetailsDialogOpen, initialForm = {} } = dialogInfo;
    const accountDetails = initialForm;

    const { allCountries, allBanks } = dropdownData;

    const closeDialog = () => setDialogInfo({});

    return (
        <Dialog
            open={vendorAccountDetailsDialogOpen}
            maxWidth={"md"}
            fullWidth
        >
            <div className={`m-3`}>

                <div className='d-flex justify-content-between'>
                    <div style={{ color: "#262626", fontSize: 16, fontWeight: 600 }}>Bank Account</div>
                    <div className='d-flex'>
                        <CrossIcon className='ml-2' onClick={closeDialog} />
                    </div>
                </div>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: "1rem",
                        margin: "1rem 0"
                    }}
                >
                    <AAutoComplete
                        label='Bank'
                        currentValue={accountDetails?.bank}
                        items={allBanks}
                        isMulti={false}
                        isDisabled
                    />

                    <AAutoComplete
                        isDisabled
                        label='Country'
                        currentValue={accountDetails?.country}
                        items={allCountries}
                        isMulti={false}
                    />

                    <div>
                        <AInput
                            label="Account Number"
                            placeholder="Enter"
                            value={accountDetails?.accountNumber}
                            maxLength={18}
                            disabled
                        />
                    </div>

                    <div>
                        <AInput
                            label="IFSC Code"
                            placeholder="Enter"
                            value={accountDetails?.ifscCode}
                            maxLength={11}
                            disabled
                        />
                    </div>

                    <div>
                        <AInput
                            label="Third Party Name"
                            placeholder="Enter"
                            value={accountDetails?.name}
                            disabled
                        />
                    </div>

                    <div>
                        <AInput
                            label="Name on Account"
                            placeholder="Enter"
                            value={accountDetails?.beneficiaryName}
                            disabled
                        />
                    </div>

                    <SelectStatus
                        bankStatus={accountDetails?.bankStatus}
                        disabled
                    />

                </div>

            </div>

        </Dialog>
    );
}

export default VendorAccountDetailsDialog;